<template>
  <div class="pwc-event-detail">
    <navigation />
    <basic-info />
    <detail-info />

    <v-dialog v-model="dialog" max-width="290" persistent>
      <v-card>
        <v-card-text>
          <p class="dialog-title"> 感谢参与！</p>
          <p class='text-c'> {{ dialogText || cDes}}</p>
          <img :src="cAssitanWechat" width="100%">
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green darken-1" flat="flat" @click="handleDialogOk"> 确定 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Navigation from '../../layout/desktop/PwcNav'
import BasicInfo from './BasicInfo'
import DetailInfo from './DetailInfo'
import { store, logic } from '../common/mixin/logic'
import { loading } from '@/mixin'
export default {
  provide() {
    return {
      event: this
    }
  },
  components: {
    Navigation,
    BasicInfo,
    DetailInfo
  },
  mixins: [store, logic, loading],
  data() {
    return {
      dialog: false,
      dialogText: '',
      eventEnd: false
    }
  },
  methods: {
    showDialogInfo(message) {
      if (message) {
        this.dialogText = message
        this.dialog = true
      }
    },
    handleDialogOk() {
      this.dialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .text-c,.dialog-title{
    font-weight: 550;
  }
  .text-c{
    padding-bottom: 16px;
    text-align: justify;
  }
  .dialog-title{
    text-align: center;
  }
</style>